import { Button, Form, Header, Menu, Text, Tab } from '@wework/dieter-ui'
import parseISO from 'date-fns/parseISO'
import format from 'date-fns/format'
import * as _ from 'lodash'
import React, { useEffect, useState } from 'react'

import EditPanelFooter from '../EditPanel/EditPanelFooter'
import EditHistory from '../EditPanel/EditHistory'
import EditMeetingRoom from '../EditPanel/EditMeetingRoom'
import EditOffice from '../EditPanel/EditOffice'
import EditPermissions from '../EditPanel/EditPermissions'
import EditPricing from '../EditPanel/EditPricing'
import EditSchedule from '../EditPanel/EditSchedule'
import EditPhysicalSpaceMeetingRoom from '../EditPanel/EditPhysicalSpaceMeetingRoom'

import { Loader } from 'semantic-ui-react'
import ReloadDialog from './ReloadDialog'
import { withSnackbar } from '../../hoc/SnackBarProvider'
import EditOther from '../EditPanel/EditOther'
import EditDesk from '../EditPanel/EditDesk'
import { useSidebar } from '../../hoc/withSidebar'
import { withFloorMap } from '@wework/react-floormap'
import EditProduct from '../EditPanel/EditProduct'
import EditProductMeetingRoom from '../EditPanel/EditProductMeetingRoom'

const product = {
  bookablePrivateOffice: 'BOOKABLE_PRIVATE_OFFICE',
  commonSpace: 'COMMON_SPACE',
  conferenceRoom: 'CONFERENCE_ROOM',
  dailyDesk: 'DAILY_DESK',
  shareableWorkspace: 'SHAREABLE_WORKSPACE',
  office: 'PRIVATE_OFFICE',
}

interface Props {
  space: any
  zIndex: number
  offsetTop: number
  floorMap: any
  snackBars: any
}

function EditDrawer({ space, floorMap, snackBars }: Props) {
  const [showHistory, setShowHistory] = useState(false)
  const [showLinkeage, setShowLinkeage] = useState(false)
  const [history, setHistory] = useState<any>(null)
  const [spaceLinked, setSpaceLinked] = useState(space?.reservable || null)
  const [showReloadDialog, setShowReloadDialog] = useState(false)
  const [roomData, setRoomData] = useState({
    ...space?.inventoryData,
    seat_count: 0,
    room_type: space?.roomType,
    office_number: space?.number,
    program_type: space?.programType,
    room_type_uuid: space?.roomTypeUUID,
    program_type_uuid: space?.programTypeUUID,
  })
  const [loading, setLoading] = useState(false)
  const { openSideBar, closeSideBar } = useSidebar()

  let isValidProduct = false
  if (
    space.inventoryData &&
    space.inventoryData?.relationships?.length > 0 &&
    (space.inventoryData?.relationships[0]?.product_type ===
      product.bookablePrivateOffice ||
      space.inventoryData?.relationships[0]?.product_type ===
        product.commonSpace ||
      space.inventoryData?.relationships[0]?.product_type ===
        product.conferenceRoom ||
      space.inventoryData?.relationships[0]?.product_type ===
        product.dailyDesk ||
      space.inventoryData?.relationships[0]?.product_type ===
        product.shareableWorkspace ||
      space.inventoryData?.relationships[0]?.product_type === product.office)
  ) {
    isValidProduct = true
  }

  useEffect(() => {
    if (!floorMap) {
      return
    }
    async function refreshRoomData() {
      const inventoryExt = floorMap.getExtension('inventoryData')

      async function fetchHistory() {
        const { data } = await inventoryExt.fetchRoomHistory(space.uuid)
        setHistory(data?.attributes?.history)
        return data
      }
      let newData: any = {}
      if (inventoryExt && space) {
        newData = (await fetchHistory()).attributes
      }

      setRoomData({
        ...space?.inventoryData,
        program_type: space?.programType,
        room_type_uuid: space?.roomTypeUUID,
        program_type_uuid: space?.programTypeUUID,
        seat_count: newData.seat_count || 0,
        sellable_bookable: newData.sellable_bookable || false,
        usable_sqft: newData.usable_sqft || 0,
        office_number: newData.office_number || space?.number,
        room_type: space?.roomType,
      })
    }

    refreshRoomData()
    setSpaceLinked(space?.reservable || null)
    return () => {
      setRoomData(null)
      setHistory(null)
      setSpaceLinked(null)
    }
  }, [floorMap, space])

  const refreshReservableAndBuildingIndex = async () => {
    const reservableExtension = floorMap.extensions.reservable

    if (!reservableExtension) {
      return
    }

    const currentBuilding = floorMap.getCurrentBuilding()
    const buildingUUID = _.get(currentBuilding, 'systemUUID')

    if (!buildingUUID) {
      return
    }

    const fetchBuildingIndex = _.get(
      floorMap,
      'extensions.buildingIndex.fetchBuildingIndex',
      () => {}
    )

    await Promise.all([
      reservableExtension.fetchOccupancies(buildingUUID),
      fetchBuildingIndex(currentBuilding.uuid),
    ])
    // reload map
    reservableExtension.reloadMapStyles()
    return
  }

  const assignSystemIdToSpace = (space, reservable) => {
    setLoading(true)
    let systemUUID = ''

    if (reservable) {
      systemUUID = reservable.uuid
    }

    return new Promise((resolve, reject) => {
      const floor = space.floorUUID

      floorMap.extensions.classification
        .assignSystemUUIDToSingleSpace(floor, systemUUID, space)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
  const onLink = async () => {
    try {
      await assignSystemIdToSpace(space, spaceLinked)
    } catch (err) {
      console.error(err)

      snackBars.addAlert({
        text: `Ops! Something went wrong, please try again.`,
        variant: 'error',
      })
      setLoading(false)
      return
    }

    try {
      await refreshReservableAndBuildingIndex()
      floorMap.updateData(space.uuid)
      floorMap.extensions.BASE_STYLE_EXTENSION.reload()
    } catch (e) {
      setShowReloadDialog(true)
    }

    setLoading(false)
    closeSideBar()
    snackBars.addAlert({
      text: `Linked successfuly!`,
      variant: 'success',
    })
  }

  const save = async () => {
    try {
      setLoading(true)
      const inventoryExt = floorMap.getExtension('inventoryData')

      if (space.roomType === 'CHAIR') {
        //@ts-ignore
        await inventoryExt.updateObject(
          floorMap.getCurrentFloor().uuid,
          space.uuid,
          {
            office_number: roomData.office_number,
          }
        )
      } else {
        //@ts-ignore
        await inventoryExt.updateRoom(
          floorMap.getCurrentFloor().uuid,
          space.uuid,
          {
            ...roomData,
          }
        )
      }

      const currentBuilding = floorMap.getCurrentBuilding()
      const currentFloor = floorMap.getCurrentFloor()
      const buildingUUID = _.get(currentBuilding, 'systemUUID')

      if (!buildingUUID) {
        return
      }

      const reservableExtension = floorMap.extensions.reservable

      if (!reservableExtension) {
        return
      }

      const fetchBuildingIndex = _.get(
        floorMap,
        'extensions.buildingIndex.fetchBuildingIndex',
        () => {}
      )

      try {
        await Promise.all([
          reservableExtension.fetchOccupancies(buildingUUID),
          fetchBuildingIndex(currentBuilding.uuid),
          inventoryExt.getInventory(currentFloor.uuid, true),
        ])
      } catch (error) {
        setShowReloadDialog(true)
      }

      // update the room data
      floorMap.updateData(space.uuid, {
        number: roomData.office_number,
        inventoryData: {
          ...roomData,
        },
        subType: roomData.room_type,
        roomType: roomData.room_type,
        programType: roomData.program_type || space.programType,
        roomTypeUUID: roomData.room_type_uuid,
        programTypeUUID: roomData.program_type_uuid,
      })

      floorMap.extensions.BASE_STYLE_EXTENSION.reload()

      // reload map
      reservableExtension.reloadMapStyles()

      setLoading(false)
      closeSideBar()

      snackBars.addAlert({
        text: `Your changes to ${space.number} have been saved.`,
        variant: 'success',
      })
    } catch (err) {
      snackBars.addAlert({
        text: `Changes failed, please try again.`,
        variant: 'failure',
      })
      setLoading(false)
      console.error(err)
    }
  }

  const getEditingSection = () => {
    switch (space?.programType) {
      case 'MEET':
        return (
          <Form>
            <EditMeetingRoom
              space={space}
              setShowLinkeage={() => openSideBar('Linkeage')}
              roomData={roomData}
              setRoomData={setRoomData}
            />
          </Form>
        )

      case 'WORK':
        if (space.roomType === 'CHAIR') {
          return (
            <Form>
              <EditDesk
                space={space}
                roomData={roomData}
                setRoomData={setRoomData}
              />
            </Form>
          )
        } else {
          return (
            <Form>
              <EditOffice
                space={space}
                roomData={roomData}
                setRoomData={setRoomData}
              />
            </Form>
          )
        }
      default:
        return (
          <Form>
            <EditOther
              space={space}
              roomData={roomData}
              setRoomData={setRoomData}
            />
          </Form>
        )
    }
  }

  const getProductEditingSection = () => {
    switch (space?.programType) {
      case 'MEET':
        return (
          <Form>
            <EditProductMeetingRoom
              space={space}
              roomData={roomData}
              setRoomData={setRoomData}
            />
          </Form>
        )

      case 'WORK':
        if (space.roomType === 'CHAIR') {
          return (
            <Form>
              <EditDesk
                space={space}
                roomData={roomData}
                setRoomData={setRoomData}
              />
            </Form>
          )
        } else {
          return (
            <Form>
              <EditProduct
                space={space}
                roomData={roomData}
                setRoomData={setRoomData}
              />
            </Form>
          )
        }
      default:
        return (
          <Form>
            <EditOther
              space={space}
              roomData={roomData}
              setRoomData={setRoomData}
            />
          </Form>
        )
    }
  }

  console.log(1, roomData)

  const panes: any = []

  panes.push({
    menuItem: { key: 'physical', content: 'Physical space' },
    render: () => (
      <Tab.Pane style={{ padding: 0 }}>{getEditingSection()}</Tab.Pane>
    ),
  })

  if (isValidProduct) {
    panes.push({
      menuItem: <Menu.Item key="product">Inventory</Menu.Item>,
      render: () => (
        <Tab.Pane style={{ padding: 0 }}>{getProductEditingSection()}</Tab.Pane>
      ),
    })
  } else {
    panes.push({
      menuItem: <Menu.Item key="product">⚠️ Inventory</Menu.Item>,
      render: () => (
        <Tab.Pane style={{ padding: 0 }}>{getProductEditingSection()}</Tab.Pane>
      ),
    })
  }

  if (isValidProduct) {
    panes.push({
      menuItem: <Menu.Item key="pricing">Pricing</Menu.Item>,
      render: () => (
        <Tab.Pane style={{ padding: 0 }}>
          <p>{getProductPricing()}</p>
        </Tab.Pane>
      ),
    })
  }

  if (isValidProduct) {
    panes.push({
      menuItem: <Menu.Item key="schedule">Schedule</Menu.Item>,
      render: () => (
        <Tab.Pane style={{ padding: 0 }}>
          <p>{getProductSchedule()}</p>
        </Tab.Pane>
      ),
    })
  }

  if (isValidProduct) {
    panes.push({
      menuItem: <Menu.Item key="permissions">Permissions</Menu.Item>,
      render: () => (
        <Tab.Pane style={{ padding: 0 }}>
          <p>{getProductPermissions()}</p>
        </Tab.Pane>
      ),
    })
  }

  const getProductPermissions = () => {
    return (
      <>
        <Form>
          <EditPermissions />
        </Form>
      </>
    )
  }

  const getProductPricing = () => {
    return (
      <>
        <Form>
          <EditPricing />
        </Form>
      </>
    )
  }

  const getProductSchedule = () => {
    return (
      <>
        <Form>
          <EditSchedule />
        </Form>
      </>
    )
  }

  const getContent = () => {
    if (showHistory) {
      return <EditHistory history={history} />
    }
    return (
      <>
        <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
      </>
    )
  }

  const getHeader = () => {
    if (showHistory) {
      return (
        <div
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            display: 'flex',
            marginBottom: 24,
          }}
        >
          <Button
            basic
            onClick={() => setShowHistory(false)}
            icon="arrow left"
            style={{ marginRight: 12 }}
          />
          <Header as="h3" style={{ margin: 0 }}>
            Edit History
          </Header>
        </div>
      )
    } else {
      return (
        <div
          style={{
            flexDirection: 'row',
            display: 'flex',
            marginBottom: 6,
            alignItems: 'center',
            width: '100%',
          }}
        >
          <div
            style={{
              flexDirection: 'column',
              display: 'flex',
              marginBottom: 6,
            }}
          >
            <div>
              <Button
                basic
                onClick={() => openSideBar('InventoryDrawer')}
                icon="arrow left"
                style={{ marginRight: 12 }}
              />
            </div>
          </div>
          <div
            style={{
              flexDirection: 'column',
              display: 'flex',
              marginBottom: 6,
              width: '100%',
            }}
          >
            <Header
              as="h3"
              style={{ margin: 0, fontSize: '24px', lineHeight: '32px' }}
            >
              Manage {space?.number}{' '}
            </Header>
            <Text
              style={{
                fontSize: '12px',
                lineHeight: '17px',
                textTransform: 'capitalize',
                color: '#666',
              }}
            >
              {space?.roomType.toLowerCase()}{' '}
            </Text>
          </div>
          <div
            style={{
              flexDirection: 'column',
              display: 'flex',
              marginBottom: 6,
              alignItems: 'flex-end',
              width: '100%',
            }}
          >
            {!history || history?.length === 0 ? null : (
              <Text style={{ color: '#666', marginLeft: 'auto' }} size="tiny">
                Last updated{' '}
              </Text>
            )}
            {!history || history?.length === 0 ? null : (
              <Text
                style={{ marginLeft: 'auto', cursor: 'pointer' }}
                size="tiny"
                primary
                onClick={() => setShowHistory(true)}
              >
                {format(parseISO(history[0].created_at), 'MMM dd, yyyy, p')}
              </Text>
            )}
          </div>
        </div>
      )
    }
  }
  const getFooter = () => {
    if (showHistory) {
      return
    }
    if (showLinkeage) {
      return (
        <div style={{ marginTop: 'auto', alignSelf: 'flex-end' }}>
          <Button
            variant="contained"
            size="small"
            onClick={() => openSideBar('EditDrawer')}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            primary
            size="small"
            onClick={() => onLink()}
            style={{ marginLeft: 12 }}
          >
            Save
          </Button>
        </div>
      )
    } else {
      return <EditPanelFooter space={space} history={history} onSave={save} />
    }
  }
  return (
    <>
      <ReloadDialog
        open={showReloadDialog}
        onClose={() => setShowReloadDialog(false)}
      />
      {loading ? (
        <div
          style={{
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
          }}
        >
          <Loader
            active
            size="medium"
            style={{
              position: 'fixed',
            }}
          >
            Saving changes...
          </Loader>
        </div>
      ) : (
        <>
          {getHeader()}
          {getContent()}
          {getFooter()}
        </>
      )}
    </>
  )
}

export default withSnackbar(withFloorMap()(EditDrawer))
